import { COLOR_TARGETS } from "../../../core/constants/color";

const useMainColors = (stepObject) => {
  let exteriorColors = null;
  let interiorColors = null;

  if (stepObject?.stepType === "COLOR") {
    const primaryColor = stepObject.stepItems.find(
      item => item.colorTarget === COLOR_TARGETS.EXTERIOR_PRIMARY
    );
    const secondaryColor = stepObject.stepItems.find(
      item => item.colorTarget === COLOR_TARGETS.EXTERIOR_SECONDARY
    );
    const keyColor = stepObject.stepItems.find(
      item => item.colorTarget === COLOR_TARGETS.INTERIOR_KEY
    );
    const interiorSecondaryColor = stepObject.stepItems.find(
      item => item.colorTarget === COLOR_TARGETS.INTERIOR_SECONDARY
    );
    const interiorThirdColor = stepObject.stepItems.find(
      item => item.colorTarget === COLOR_TARGETS.INTERIOR_THIRD
    );

    if (primaryColor || secondaryColor) {
      exteriorColors = { primaryColor, secondaryColor, stepObject };
    }

    if (keyColor || interiorSecondaryColor || interiorThirdColor) {
      interiorColors = {
        keyColor,
        secondaryColor: interiorSecondaryColor,
        thirdColor: interiorThirdColor,
        stepObject
      };
    }
  }

  return { exteriorColors, interiorColors };
};

export default useMainColors;
